import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Header() {
  // 状態管理は const で行います
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 bg-white shadow-sm transition-all duration-300 ${isScrolled ? 'bg-gray-100' : ''}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-12 sm:h-14">
          <Link to="/" className="flex items-center space-x-2 cursor-pointer">
            <img 
              src="https://static.readdy.ai/image/f95cd9c4b1c2dbe7a0ca3fd438a74a8e/265a4ab5bb28f89ea2ae593d4e828e60.jfif" 
              alt="トラストロゴ" 
              className="h-8 sm:h-10 w-auto"
            />
          </Link>
          <div className="flex items-center space-x-2 sm:space-x-3">
            <a 
              href="tel:052-887-6243" 
              className="bg-blue-500 text-white px-2.5 sm:px-3 py-1.5 rounded-full hover:bg-blue-600 transition-colors flex items-center space-x-1 whitespace-nowrap text-xs font-medium cursor-pointer"
            >
              <div className="w-3.5 h-3.5 flex items-center justify-center">
                <i className="ri-phone-line text-xs"></i>
              </div>
              <span>TEL</span>
            </a>
            <a 
              href="https://lin.ee/MJ3LVM2" 
              target="_blank"
              rel="noopener noreferrer"
              className="bg-[#06C755] text-white px-2.5 sm:px-3 py-1.5 rounded-full hover:bg-[#05b34c] transition-colors flex items-center space-x-1 whitespace-nowrap text-xs font-medium cursor-pointer"
            >
              <div className="w-3.5 h-3.5 flex items-center justify-center">
                <i className="ri-line-fill text-xs"></i>
              </div>
              <span>LINE</span>
            </a>
          </div>
        </div>
      </div>
    </header>
  );
}